<template lang="pug">
  .content
    .mr-5.d-flex.flex-wrap.align-items-center(v-if="!premiumUser && subBoxVisible && !userClosedBar")
      //- .box-info-subscription.d-flex.flex-wrap
      //-   span.flex-1 Need more <b>syncs</b>? No worries, try <b> Smart Sync Business</b>!
      //-   img(src="@/assets/imgs/upgradeButton.svg").mr-2
      //-   img(src="@/assets/imgs/hideBoxButton.svg", @click="userClosedBar=true").mr-2

    .breadcrumb-custom(v-if="breadcrumb")
      .d-flex 
        span 
          router-link(to="/").no-decoration {{breadcrumb.from}}
          |  / 
          b {{breadcrumb.to}}
    .storeName.ml-5.mr-5(v-if="user").float-right
        | {{shopName}}
</template>

<script>
import {Auth} from '../../helpers'
import {AUTH_USER_SHOP} from '../../tools'
export default {
  name: 'Topbar',
  props:{},
  watch: {
      '$route'(){
          this.activeLink = this.$route.meta.activeLink
      }
  },
  data () {
    return {
        user: Auth.user,
        premiumUser: false,
        userClosedBar: false,
        shopName: null
    }
  },
  mounted () {
      this.activeLink = this.$route.meta.activeLink
      if(this.user){
        this.shopName = localStorage.getItem(AUTH_USER_SHOP);
      }
  },
  methods: {
    logOut(){
      Auth.logOutUser();
      window.location.href = "/"
    }
  },
  computed: {
      subBoxVisible() {
        return this.$route.meta.showPremiumBanner ?? false
      },
      breadcrumb(){
        return this.$route.meta.breadcrumb ?? false
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  @import url('@/less/global.less'); 
 nav {
     padding: 0;
 }
 .nav-link {
   cursor: pointer
 }
 .box-info-subscription {
     background-color: #C0F1EA;
     border: solid 1px #32CCB7;
     padding: 15px;
     border-radius: 4px;
 }
 .box-info-subscription {
     flex:1
 }
 .content {
     display:flex;
     align-items:stretch;
     justify-content: space-between;
     width:100%;
 }
 .flex-1 {
     flex:1
 }

</style>
